import { PageTypes } from "enums/pageTypes";
import { useLocation } from "react-router-dom";

export const usePageType = () => {
  const location = useLocation();
  const isAdmin = location?.pathname.includes(PageTypes.Admin) || false;

  return isAdmin ? PageTypes.Admin : PageTypes.TeamManager;
};
